/**
 * Meta (Facebook/Instagram) pixel for the sign-up conversion of the ad
 * campaigns. The app has no cookie banner of its own: consent is given on
 * seller2go.com, whose banner (vanilla-cookieconsent) stores it in the
 * `cc_cookie` cookie on `.seller2go.com`. The pixel is only loaded when the
 * visitor accepted the "marketing" category there; otherwise nothing is sent.
 */

const META_PIXEL_ID = '1436456657862552';
const CONSENT_COOKIE_NAME = 'cc_cookie';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

const hasMarketingConsent = (): boolean => {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`));
  if (!match) {
    return false;
  }
  try {
    const consent = JSON.parse(decodeURIComponent(match.slice(CONSENT_COOKIE_NAME.length + 1)));
    return Array.isArray(consent?.categories) && consent.categories.includes('marketing');
  } catch {
    return false;
  }
};

// Official Meta snippet, rewritten without the minification.
const loadPixel = (): Fbq => {
  const w = window as unknown as { fbq?: Fbq; _fbq?: Fbq };
  if (w.fbq) {
    return w.fbq;
  }
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  w.fbq = fbq;
  w._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  fbq('init', META_PIXEL_ID);
  return fbq;
};

/** Reports a finished registration to Meta, only with marketing consent. */
export const trackCompleteRegistration = (): void => {
  if (!hasMarketingConsent()) {
    return;
  }
  loadPixel()('track', 'CompleteRegistration');
};
